// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2gzEu","label":"Labeled_label__1m2wp","divider":"Labeled_divider__1O12W"};